export default [
  { pathName: '/usuarios', tituloPagina: 'Usuários' },
  { pathName: '/clientes', tituloPagina: 'Clientes' },
  { pathName: '/fazendas', tituloPagina: 'Fazendas' },
  { pathName: '/funcionalidades', tituloPagina: 'Acessos' },
  // { pathName: '/ingredientes', tituloPagina: 'Ingredientes' },
  // { pathName: '/fabricantes', tituloPagina: 'Fabricantes' },
  { pathName: '/relatorio', tituloPagina: 'Relatórios' }
  // { pathName: '/usuarios/vinculos', tituloPagina: 'Vincular usuário' },
];
